import { render, staticRenderFns } from "./AccountNotSetUp.vue?vue&type=template&id=8580e2b4&scoped=true&"
import script from "./AccountNotSetUp.vue?vue&type=script&lang=ts&"
export * from "./AccountNotSetUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8580e2b4",
  null
  
)

export default component.exports